import React from 'react'  
import { Link } from "react-router-dom";

class NotFound extends React.Component {  
    
    render() {
        // TODO: odlisovat, kdy ma byt "/" a kdy "/:council_id/"

        return (
            <div className='sm:pt-3 md:pt-5 lg:pt-8'>
                <span className="p-3 mb-3 flex flex-column align-items-center">
                    <i className="pi bi-emoji-frown text-8xl text-primary"></i>
                    <span className='text-8xl text-primary font-semibold'>404</span>
                    <div className="text-900 text-2xl mt-2 text-center">
                        Požadovaná stránka nebyla bohužel nalezena.
                        <br></br>
                        Můžete se vrátit na <Link style={{ color: '#6366F1', fontWeight: 600 }} to={`/`} key='home'>domovskou stránku</Link>.
                    </div>
                </span>
            </div>
        );
        
    }
}

export default NotFound;
